import React, { useState, useEffect } from 'react';
import partnerService from '../services/partnerService';

const PartnerSelect = ({ name, value, onChange, disabled, required, placeholder }) => {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchPartners();
  }, []);

  const fetchPartners = async () => {
    try {
      setLoading(true);
      const response = await partnerService.getAllPartners();
      setPartners(response.data.partners || []);
    } catch (err) {
      setError('Failed to load partners');
      console.error('Error fetching partners:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <select name={name} disabled>
        <option>Loading partners...</option>
      </select>
    );
  }

  if (error) {
    return (
      <select name={name} disabled>
        <option>Error loading partners</option>
      </select>
    );
  }

  return (
    <select
      name={name}
      value={value || ''}
      onChange={onChange}
      disabled={disabled}
      required={required}
    >
      <option value="">{placeholder || 'Select a partner...'}</option>
      {partners.map(partner => (
        <option key={partner.partnerid} value={partner.partnerid}>
          {partner.companyname}
        </option>
      ))}
    </select>
  );
};

export default PartnerSelect;
